let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7nT3z")).then(() => parcelRequire('3f2BD'));